import ProfileSummary from './profileSummary';
import User from './user';

export type InviteParentType = 'Group' | 'Event' | 'GroupChat';

export default class InviteResponse {
  profile: ProfileSummary;
  title: string;
  inviteId: number;
  parentId: number;
  parentType: InviteParentType;

  constructor() {
    this.profile = new ProfileSummary();
    this.title = '';
    this.inviteId = 0;
    this.parentId = 0;
    this.parentType = 'Group';
  }

  /**
   * Static method to map a plain object (typically from an API response)
   * to an InviteResponse instance, converting PascalCase keys to camelCase.
   * @param _obj The raw object to map from.
   * @returns A new InviteResponse instance with mapped data.
   */
  static mappingObject(_obj: Record<string, any>): InviteResponse {
    const obj = new InviteResponse();

    // Map the nested ProfileSummary object
    if (_obj.Profile) {
      obj.profile = ProfileSummary.mappingObject(_obj.Profile);
    }

    // Map other properties, handling potential missing values
    obj.title = _obj.Title || obj.title;
    obj.inviteId = _obj.InviteID || obj.inviteId; // Mapping from PascalCase 'InviteID'
    obj.parentId = _obj.ParentID || obj.parentId; // Mapping from PascalCase 'ParentID'
    // For 'parentType', ensure it's one of the allowed literal types
    if (_obj.ParentType === 'Club' || _obj.ParentType === 'Event') {
      obj.parentType = _obj.ParentType;
    } else {
      // If ParentType is not valid, retain default or handle error
      obj.parentType = obj.parentType; // Retains 'Club' as default
    }

    return obj;
  }

  static mappingObjects(arr: Record<string, any>[]) {
    const data: InviteResponse[] = [];
    arr.forEach(_item => {
      data.push(InviteResponse.mappingObject(_item));
    });
    return data;
  }
}
